import type { TableColumnsType } from "antd";
import { Button, Table } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getOldSystemPayments } from "../../../apis/actions/sponsor.actions";
import { RootState } from "../../../apis/store";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import PdfPreview from "../../../biblio/Modal/PdfPreview";
import CustomConfigProvider from "../ProfileHeader";

const OldSystemPayments = () => {
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState<string>("");

  useEffect(() => {
    setLoading(true);
    getOldSystemPayments({ sponsor_id: otpId })
      .then((result) =>
        setPayments(Array.isArray(result) ? result : result?.data ?? [])
      )
      .catch(() => setPayments([]))
      .finally(() => setLoading(false));
  }, [otpId]);

  const columns: TableColumnsType<any> = [
    {
      title: "الاسم",
      dataIndex: "name",
      render: (text: string) => (
        <b className="takaful--text-color-blue">
          <span>{text ?? "-"}</span>
        </b>
      ),
    },
    {
      title: "الرابط",
      dataIndex: "url",
      render: (url: string) =>
        url ? (
          <Button type="link" onClick={() => setPdfUrl(url)}>
            عرض
          </Button>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div className="takaful--sponsor-donation-payment">
      <CustomConfigProvider title="مدفوعات النظام القديم"></CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ minHeight: "20vh" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : (
        <Table<any>
          style={{ direction: "rtl" }}
          columns={columns}
          dataSource={payments}
          rowKey={(record, index) => record?.id ?? record?.url ?? index}
          className="takaful--sponsor-table"
          scroll={{ x: "max-content" }}
          pagination={false}
          locale={{ emptyText: "لا يوجد دفعات" }}
        />
      )}
      <PdfPreview
        open={pdfUrl !== ""}
        onClose={() => setPdfUrl("")}
        url={pdfUrl}
        isBlob={false}
        className="takaful--pdf-preview-modal"
      />
    </div>
  );
};

export default OldSystemPayments;
